import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';


export default function (getValidated, getWarnings) {
    return function (value) {
        const validated = getValidated(value);
        const warnings = (getWarnings) ? getWarnings(value) : false;
        let className = (validated) ? '' : 'value-invalid';
        if (validated && warnings) {
            className = 'value-warning';
            return (
                <OverlayTrigger 
                    placement='top'
                    overlay={<Tooltip>This value must be greater than previous</Tooltip>}>
                    <span className={className}>{value}</span>
                </OverlayTrigger>);
        } else {
            return (<span className={className}>{value}</span>);
        }
    }
};